import { generateTranslations } from '../i18n/translation';

const namespace = 'godtabetingelser';

const translations = generateTranslations(namespace, {
  page1Title: {
    nb: 'Arbeidslivsportalen',
    en: 'Arbeidslivsportalen',
  },
  page2TitleStudent: {
    nb: 'Som student i praksis',
    en: 'As a student in work placement',
  },
  page2TitleStudiested: {
    nb: 'Som ansatt ved studiested',
    en: 'As employee at an educational institution',
  },
  page2TitlePraksissted: {
    nb: 'Som ansatt ved praksissted',
    en: 'As employee at work placement institution',
  },
  page1Description: {
    nb: 'En samhandlingsplattform mellom utdanning, student og arbeidslivet.',
    en: 'A cooperation platform between education, student and work place.',
  },
  cancel: {
    nb: 'Avbryt',
    en: 'Cancel',
  },
  neste: {
    nb: 'Neste',
    en: 'Next',
  },
  godkjenn: {
    nb: 'Godkjenn',
    en: 'Accept',
  },
  jegGodkjenner: {
    nb: 'Jeg har lest og godtar personvernbetingelsene.',
    en: 'I have read and accept the policy conditions',
  },
});

export default translations;
